<div class="avatar-search-row position-relative">
  <div class="avatar-search-row  q-pointer" [ngbPopover]="f1"
       [placement]="[placement, 'auto']"
       [autoClose]="'outside'"
       container="body"
       #p1="ngbPopover"     
       popoverClass="popover-avatar-search-class">
    <div class="container-user-plus">
      <i *ngIf="!selectedList || selectedList.length === 0" [ngClass]="[multipleSelection ? 'fas fa-user-plus fa-flip-horizontal' : 'fas fa-user']"></i>
      <ng-container *ngIf="selectedList && selectedList.length > 0">
        <img *ngIf="selectedList && selectedList.length > 0 && selectedList[0] && selectedList[0][imgPropName]"
             loading="lazy"
             class="rounded-img q-pointer"
             [src]="getUrl(selectedList[0][imgPropName])"
             [title]="GetListElement()"
             alt="" /> 
      </ng-container>
    </div>
    <ng-container *ngIf="multipleSelection && selectedList.length > 1">
      <div style="width: 20px;"></div>
      <div class="selected-element-container" style="width: 35px;">
        <div style="left: 20px;" [title]="GetListElement()">+{{selectedList.length - 1}}</div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #f1>
  <div class="w-100">
    <form #form>
      <div class="avatar-search-row justify-content-center align-items-center mb-3">
        <input name="input" type="text" class="input-style"
               [(ngModel)]="inputValue"
               [placeholder]="placeholder" />
        <div class="col-auto input-search-container">
          <i class="fas fa-search"></i>
        </div>
      </div>
    </form>
  </div>
  <div #cdkViewportContainer class="elements-container" [style.height.px]="(elementList.length * 35) + 70" [style.width]="domSanitizer.bypassSecurityTrustStyle(SetCdkViewportWidth(cdkViewportContainer))">
    
    <cdk-virtual-scroll-viewport  class="h-100" style="overflow-x:hidden;" itemSize="33" >

      <ng-container *cdkVirtualFor="let bloc of elementList | avatarSearchRenderer: selectedList: inputValue: nullable: multipleSelection: labelPropName: identPropName: delayDisplaySelectedElementsList: delayDisplayUnselectedElementsList">
        <ng-container *ngIf="bloc.NameElementToRender === 'selectedElements'">
          <div *ngIf="bloc.TypeElementToRender === 'Header'" class="mb-3">
            <span class="q-c-main q-bold q-pointer" (click)="OnDisplaySelectedElementsList();"><i class="mr-2 q-c-main fas" [ngClass]="[displaySelectedElementsList ? 'fa-angle-down' : 'fa-angle-up']"></i>{{multipleSelection ? 'Sélectionnés' : 'Sélectionné'}}{{multipleSelection ? ' (' + selectedList.length + ')' : ''}}</span>
            <span *ngIf="multipleSelection" class="q-btn-border q-danger q-pointer select-all-span" (click)="RemoveAll()">Retirer tous</span>
          </div>
          <ng-container *ngIf="bloc.TypeElementToRender === 'Body' && delayDisplaySelectedElementsList">
            <div class="avatar-search-row align-items-center q-pointer position-relative mb-2"
                 (click)="RemoveElement(bloc[identPropName], p1);"
                 [ngClass]="[displaySelectedElementsList ? 'displayElementsList' : 'hideElementsList']">
              <div class="background-element"></div>
              <img *ngIf="bloc && bloc[imgPropName]"
                   loading="lazy"
                   [title]="bloc[labelPropName]"
                   class="img-hovered rounded-img mr-2"
                   [src]="getUrl(bloc[imgPropName])"
                   alt="" />

              <span>{{bloc[labelPropName]}}</span>

              <div class="ml-auto rounded-times-container">
                <div class="rounded-times q-danger" *ngIf="(selectedList && selectedList.length > 0) && (nullable || (!nullable && multipleSelection && selectedList && selectedList.length > 1))">
                  <i class="fas fa-times fa-xs"></i>
                </div>
              </div>

            </div>
          </ng-container>

          <hr *ngIf="bloc.TypeElementToRender === 'Hr'" />
        </ng-container>

        <ng-container *ngIf="bloc.NameElementToRender === 'unselectedElements'">
          <ng-container *ngIf="bloc.TypeElementToRender === 'Header'">
            <div class="mb-3" *ngIf="(elementList && elementList.length > 0 && elementList.length != selectedList.length) && (nullable || multipleSelection)">
              <span class="q-c-main q-bold q-pointer"  (click)="OnDisplayUnselectedElementsList();"><i class="mr-2 q-c-main fas" [ngClass]="[displayUnselectedElementsList ? 'fa-angle-down' : 'fa-angle-up']"></i>Disponibles ({{elementList.length - selectedList.length}})</span>
              <span *ngIf="multipleSelection" class="q-btn-border q-success q-pointer select-all-span" (click)="AddAll()">Ajouter tous</span>
            </div>
          </ng-container>
          <ng-container *ngIf="bloc.TypeElementToRender === 'Body' && delayDisplayUnselectedElementsList">
            <div class="avatar-search-row align-items-center q-pointer position-relative mb-2"
                 (click)="AddElement([bloc[identPropName]], p1, true);"
                 [ngClass]="[displayUnselectedElementsList ? 'displayElementsList' : 'hideElementsList']">
              <div class="background-element"></div>
              <img *ngIf="bloc && bloc[imgPropName]"
                   loading="lazy"
                   [title]="bloc[labelPropName]"
                   class="img-hovered rounded-img mr-2"
                   [src]="getUrl(bloc[imgPropName])"
                   alt="" />         

              <span>{{bloc[labelPropName]}}</span>

              <div class="ml-auto rounded-times-container">
                <div class="rounded-times q-success">
                  <i class="fas fa-plus fa-xs"></i>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

      </ng-container>
    </cdk-virtual-scroll-viewport>
  </div> 
</ng-template>
